import 'reflect-metadata';

import { Decoder, Encoder } from '@iotize/common/converter/api';
import { TapRequestFrame } from '@iotize/tap/client/api';

interface LWM2MMethodMeta<T = unknown> {
  method?: TapRequestFrame.MethodType;
  path: string;
  auth?: string[];
  configModeRequired?: boolean;
  payloadType?: Decoder<Uint8Array, T>;
  responseType?: Encoder<T, Uint8Array>;
}

export interface GetMetaData<T> extends LWM2MMethodMeta<T> {}

export const GET_META_DATA_KEY = Symbol('GET');

export function GET(meta: GetMetaData<any>) {
  meta.method = TapRequestFrame.MethodType.GET;
  return Reflect.metadata(GET_META_DATA_KEY, meta);
}

export interface PostMetaData<T> extends LWM2MMethodMeta<T> {}
export const POST_META_DATA_KEY = Symbol('POST');

export function POST(meta: PostMetaData<any>) {
  meta.method = TapRequestFrame.MethodType.POST;
  return Reflect.metadata(POST_META_DATA_KEY, meta);
}

export interface PutMetaData<T> extends LWM2MMethodMeta<T> {}

export const PUT_META_DATA_KEY = Symbol('PUT');

export function PUT(meta: PutMetaData<any>) {
  meta.method = TapRequestFrame.MethodType.PUT;
  return Reflect.metadata(PUT_META_DATA_KEY, meta);
}
